<template>
    <div class="unsettled">
        <DetailCard 
            :hide="contents.loading || !contents.details.length"
            :details="contents.details"
            title="SETTLEMENT"
            backUrl="/dashboard/settlements/transactions"
            subTitle="Transaction Details"
            :subDetailTitle="contents.subDetails.title"
            :subDetailContents="contents.subDetails.details"
        />     
        <div class="loading" v-if="contents.loading">
          <Loader /> 
        </div> 
    <div class="margin" v-if="!contents.loading && !contents.details.length" >
      <NoContent >
          <template>
              <h1>No Transaction Found</h1>
              <p>Transaction details will show here</p>
          </template>
      </NoContent>
  </div>
    </div>
</template>
<script>
import { reactive, onBeforeMount, computed, onMounted } from '@vue/composition-api'
import DetailCard from '@/components/detailcard.vue';
import Loader from '@/components/loader.vue';
import SubDetail from '@/components/subdetail.vue'; 
import NoContent from "@/components/noContent.vue"

export default {
    components: {
        DetailCard,
        SubDetail,
        Loader,
        NoContent
    },
    setup(props, { root }) {
        const params = root.$route.params;
        const store = root.$store;

        const contents = computed(() => store.getters.getSettlementTransactionDetailChunk);

        onBeforeMount(() => {
           store.dispatch("getSettlementTransactions", { transaction_id: `${root.$route.params.id}` });
        })

        return {
            contents
        }
    }
}
</script>
<style lang="scss" scoped>
  .unsettled {
      display: flex;
      flex-grow: 1;
      position: relative;
      flex-direction: column;

      .margin {
        width: 95%;
        margin: 40px 0;
      }
      
      .loading, .no-content{
          margin: 0 30px;
      }

      > div {
       flex-grow: 1;
      }
  }
</style>